/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassRosterRequest
 */
export interface ClassRosterRequest {
    /**
     * 
     * @type {string}
     * @memberof ClassRosterRequest
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassRosterRequest interface.
 */
export function instanceOfClassRosterRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassRosterRequestFromJSON(json: any): ClassRosterRequest {
    return ClassRosterRequestFromJSONTyped(json, false);
}

export function ClassRosterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassRosterRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
    };
}

export function ClassRosterRequestToJSON(value?: ClassRosterRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
    };
}

